import React, { useState, useCallback } from 'react';
import UnifiedInputHub from './UnifiedInputHub';
import HistoryPage from './HistoryPage';

/**
 * Coaching — the single self-service surface: analyze a new speech (upload /
 * record / URL) up top, and the full history of analyzed speeches below.
 * Merges the former /analyze and /history pages.
 */
export default function CoachingPage() {
  // Bumped when an analysis finishes so the history list (and usage banner)
  // remount and refetch, surfacing the speech that was just analyzed.
  const [refreshKey, setRefreshKey] = useState(0);
  const handleAnalysisComplete = useCallback(() => setRefreshKey(k => k + 1), []);

  return (
    <div className="space-y-8">
      <div className="card-paper p-6">
        <UnifiedInputHub onAnalysisComplete={handleAnalysisComplete} />
      </div>

      <div>
        <div className="flex items-center gap-2.5 mb-4">
          <div className="w-0.5 h-3 rounded-full flex-shrink-0"
               style={{ background: 'linear-gradient(180deg, var(--accent) 0%, rgba(0,0,0,0) 100%)' }} />
          <h2 className="font-mono text-[10px] font-medium uppercase tracking-[0.2em]"
              style={{ color: 'var(--text-faint)' }}>
            Your analyzed speeches
          </h2>
        </div>
        <HistoryPage key={refreshKey} />
      </div>
    </div>
  );
}
